.HeroInTune {
    position: relative;
    display: grid;
    place-items: center;
    overflow: hidden;
    font-family: var(--soniq-t--global--font--family--sans);
    background: var(--soniq-t--global--background--gradient--primary-glow);

    /*
     * Forcing a colour scheme cannot go through the semantic tokens.
     * Those are declared on :root, and a custom property is resolved
     * where it is declared — so a token has already settled on the
     * page's scheme by the time it reaches this element. Setting
     * `color-scheme` here comes too late to change it.
     *
     * So pin the colours that carry the scheme: the background base,
     * the eyebrow border and the title. Rules that call light-dark()
     * directly (the subtitle, and both text shadows) resolve against
     * this element and need no override.
     *
     * The gradient sitting over the base still takes its outer stop
     * from the page's scheme. That stop is at 5% alpha, so the
     * difference does not show — worth knowing before making it
     * stronger.
     */
    &.isSchemeLight {
        color-scheme: light;
        background-color: var(--soniq-t--global--palette--white);

        .HeroInTune__eyebrow {
            border-color: rgba(0, 0, 0, 0.15);
        }

        .HeroInTune__title {
            color: #000;
        }
    }

    &.isSchemeDark {
        color-scheme: dark;
        background-color: var(--soniq-t--global--palette--black);

        .HeroInTune__eyebrow {
            border-color: rgba(255, 255, 255, 0.15);
        }

        .HeroInTune__title {
            color: #fff;
        }
    }
}

.HeroInTune__canvas {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    display: block;
}

.HeroInTune__content {
    position: relative;
    z-index: 1;
    text-align: center;
    padding: 24px;
    max-width: 720px;
}

.HeroInTune__eyebrow {
    display: inline-block;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    color: var(--soniq-t--global--palette--hot-pink);
    border: 1px solid var(--soniq-t--global--border--color--card--default);
    border-radius: 999px;
    padding: 6px 14px;
    margin-bottom: 22px;
    backdrop-filter: blur(2px);
}

.HeroInTune__title {
    margin: 0;
    font-size: clamp(38px, 6vw, 64px);
    font-weight: 800;
    letter-spacing: -0.5px;
    line-height: 1.05;
    color: var(--soniq-t--global--text--color--primary--default);
    text-shadow: light-dark(rgba(255, 255, 255, 0.4), rgba(0, 0, 0, .6)) 0 0 3px;
}

.HeroInTune__subtitle {
    margin: 18px 0 0;
    font-size: clamp(18px, 2vw, 22px);
    line-height: 1.6;
    color: light-dark(#000, #fff);
    text-shadow: light-dark(rgba(255, 255, 255, 0.5), #000) 1px 0 2px;
}

.HeroInTune__actions {
    margin-top: 30px;
    display: flex;
    gap: 12px;
    justify-content: center;
    flex-wrap: wrap;
}
